<template>
	<div
		class="flow-sel-card-container"
		:selected="selected"
		:tabindex="tabindex"
		:disabled="disabled"
		@click="handleClick($event)"
	>
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "SelectionCard",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * true | false
		 */
		selected: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			if (!this.disabled) {
				this.$emit("click", e);
			}
		}
	}
});
</script>
<style lang="scss">
div.flow-sel-card-container {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 24px;

	background-color: var(--slideout-element-light);
	border: 1px solid var(--slideout-border);
	border-radius: 12px;
	flex-direction: column;

	&:active:not([disabled]) {
		filter: contrast(90%);
	}

	&:hover:not(:active):not([disabled]) {
		filter: contrast(95%);
		cursor: pointer;
	}
	&:focus:not([disabled]) {
		box-shadow: inset 0 0 0 1px var(--slideout-primary);
		outline: none;
	}
	&:after {
		position: absolute;
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
		opacity: 1;
		transition: opacity 0.3s linear;
	}
	&[selected] {
		box-shadow: inset 0 0 0 1px var(--slideout-success);
		outline: none;
		position: relative;
		&:after {
			background-color: var(--dashboard-success-light);
			content: "";
			opacity: 0.2;
		}
	}
	&[disabled] {
		filter: opacity(0.3);
		cursor: not-allowed;
	}
}
</style>
